/* eslint-disable react/prop-types */
import React, { useState } from "react";
import FadeIn from "../common/FadeIn";
import FilterMenu from "../common/FilterMenu";
import { Container, Row, Col, Button, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import { isAuthenticatedCustomer } from "./services/CustomerAuth.js"; //import auth

const CustomerClassViewer = (props) => {
  const classes = props.classes;
   // Manage State
  const [filterDay, setFilterDay] = useState(
    JSON.parse(window.sessionStorage.getItem("filterDay"))
  );
  const [filterVenue, setFilterVenue] = useState(
    JSON.parse(window.sessionStorage.getItem("filterVenue"))
  );
  const [filterLessonType, setFilterLessonType] = useState(
    JSON.parse(window.sessionStorage.getItem("filterLessonType"))
  );
  const [filterTutor, setFilterTutor] = useState(
    JSON.parse(window.sessionStorage.getItem("filterTutor"))
  );
  const [filterAvailableClasses, setFilterAvailableClasses] = useState(
    JSON.parse(window.sessionStorage.getItem("filterAvailableClasses"))
  );

  //Filter out Classes where tutor not set
  const tutoredClasses = classes.filter((e) => {
    return e.Tutor;
  });
  //Create Array of Unique LessonTypes
  const LessonTypes = [...new Set(classes.map((q) => q.LessonType))].sort();
  //Create Array of Unique Venues
  const Venues = [...new Set(classes.map((v) => v.Venue.VenueName))].sort();
  //Create Array of Unique Tutors
  const Tutors = [...new Set(tutoredClasses.map((v) => v.Tutor.First_Name))].sort();
  // Variables
  let filteredClasses;
  let firstStageClasses;
  let classesToFilter;
  //If the filter for tutored Classes is set, change the array
  if (filterTutor) {
    firstStageClasses = tutoredClasses;
  } else {
    firstStageClasses = classes;
  }
  //Filter first first for available classes only (those classes with free spaces)
  const availableClasses = firstStageClasses.filter((e) => {
    return e.Subscribers_Number < e.MaxLearners;
  });
  //Filter Classes for if "available classes" is selected.
  if (filterAvailableClasses === "true") {
    classesToFilter = availableClasses;
  } else {
    classesToFilter = firstStageClasses;
  }
  // Conditional Logic for Filters
  //no filters
  if (!filterDay && !filterVenue && !filterLessonType && !filterTutor) {
    filteredClasses = classesToFilter;
  }
  //filter day only
  else if (filterDay && !filterVenue && !filterLessonType && !filterTutor) {
    filteredClasses = classesToFilter.filter((t) => {
      return t.Day === filterDay;
    });
  }
  //filter venue only
  else if (!filterDay && filterVenue && !filterLessonType && !filterTutor) {
    filteredClasses = classesToFilter.filter((t) => {
      return t.Venue.VenueName === filterVenue;
    });
  }

  //filter LessonType only
  else if (!filterDay && !filterVenue && filterLessonType && !filterTutor) {
    filteredClasses = classesToFilter.filter((t) => {
      return t.LessonType === filterLessonType;
    });
  }

  //filter Tutor only
  else if (!filterDay && !filterVenue && !filterLessonType && filterTutor) {
    filteredClasses = classesToFilter.filter((t) => {
      return t.Tutor.First_Name === filterTutor;
    });
  }

  //filter venue & day but not LessonType or tutor
  else if (filterDay && filterVenue && !filterLessonType && !filterTutor) {
    filteredClasses = classesToFilter.filter((t) => {
      return (t.Venue.VenueName === filterVenue) & (t.Day === filterDay);
    });
  }

  //filter venue & LessonType but not Day or tutor
  else if (!filterDay && filterVenue && filterLessonType && !filterTutor) {
    filteredClasses = classesToFilter.filter((t) => {
      return (t.Venue.VenueName === filterVenue) & (t.LessonType === filterLessonType);
    });
  }

  //filter Day & LessonType but not venue or tutor
  else if (filterDay && !filterVenue && filterLessonType && !filterTutor) {
    filteredClasses = classesToFilter.filter((t) => {
      return (t.Day === filterDay) & (t.LessonType === filterLessonType);
    });
  }

  //Filter tutor and Venue
  else if (!filterDay && filterVenue && !filterLessonType && filterTutor) {
    filteredClasses = classesToFilter.filter((t) => {
      return (t.Venue.VenueName === filterVenue) & (t.Tutor.First_Name === filterTutor);
    });
  }

  //filter tutor and day
  else if (filterDay && !filterVenue && !filterLessonType && filterTutor) {
    filteredClasses = classesToFilter.filter((t) => {
      return (t.Day === filterDay) & (t.Tutor.First_Name === filterTutor);
    });
  }

  //filter tutor and lessonType
  else if (!filterDay && !filterVenue && filterLessonType && filterTutor) {
    filteredClasses = classesToFilter.filter((t) => {
      return (t.LessonType === filterLessonType) & (t.Tutor.First_Name === filterTutor);
    });
  }

  //filter Day & LessonType & venue but not Tutor
  else if (filterDay && filterVenue && filterLessonType && !filterTutor) {
    filteredClasses = classesToFilter.filter((t) => {
      return (
        (t.Day === filterDay) &
        (t.LessonType === filterLessonType) &
        (t.Venue.VenueName === filterVenue)
      );
    });
  }
  //filter Day & LessonType & Tutor but not LessonType
  else if (filterDay && filterVenue && !filterLessonType && filterTutor) {
    filteredClasses = classesToFilter.filter((t) => {
      return (
        (t.Day === filterDay) &
        (t.Tutor.First_Name === filterTutor) &
        (t.Venue.VenueName === filterVenue)
      );
    });
  }
  //filter Day & LessonType & Tutor but not Venue
  else if (filterDay && !filterVenue && filterLessonType && filterTutor) {
    filteredClasses = classesToFilter.filter((t) => {
      return (
        (t.Day === filterDay) &
        (t.LessonType === filterLessonType) &
        (t.Tutor.First_Name === filterTutor)
      );
    });
  }
  //filter Day & LessonType & Tutor but not Day
  else if (!filterDay && filterVenue && filterLessonType && filterTutor) {
    filteredClasses = classesToFilter.filter((t) => {
      return (
        (t.Tutor.First_Name === filterTutor) &
        (t.LessonType === filterLessonType) &
        (t.Venue.VenueName === filterVenue)
      );
    });
  }

  //Filter All
  else if (filterDay && filterVenue && filterLessonType && filterTutor) {
    filteredClasses = classesToFilter.filter((t) => {
      return (
        (t.Day === filterDay) &
        (t.Tutor.First_Name === filterTutor) &
        (t.LessonType === filterLessonType) &
        (t.Venue.VenueName === filterVenue)
      );
    });
  }

  return (
    <div className='CustomerClassViewer'>
      <FadeIn delay={250} duration={450}>
          <div>
            {classes.length !== 0 ? (
              <Container className='mb-5 mt-2'>
                <h1 className='text-center mb-2'>Regular Bookings</h1>
                <FilterMenu
                  filterVenue={filterVenue}
                  filterDay={filterDay}
                  filterLessonType={filterLessonType}
                  filterTutor={filterTutor}
                  filterAvailableClasses={filterAvailableClasses}
                  Venues={Venues}
                  Tutors={Tutors}
                  LessonTypes={LessonTypes}
                  setFilterVenue={setFilterVenue}
                  setFilterDay={setFilterDay}
                  setFilterLessonType={setFilterLessonType}
                  setFilterTutor={setFilterTutor}
                  setFilterAvailableClasses={setFilterAvailableClasses}
                />
                {filteredClasses.length !== 0 ? (
                  <>
                    {" "}
                    {Venues.map((Venue) => (
                      <VenueBlock key={Venue} filteredClasses={filteredClasses} Venue={Venue}/>
                    ))}
                  </>
                ) : (
                  <Row>
                    <Col sm='12' className='shadow mt-4 p-3 border text-center'>
                      <div>
                        <h3>No classes returned. Try filtering again.</h3>
                      </div>
                    </Col>
                  </Row>
                )}
              </Container>
            ) : (
              <div />
            )}
          </div>
      </FadeIn>
    </div>
  );
};

const VenueBlock = (props) => {
  //Sort the days by number.
  const daySorter = {
    Monday: 1,
    Tuesday: 2,
    Wednesday: 3,
    Thursday: 4,
    Friday: 5,
    Saturday: 6,
    Sunday: 7,
  };

  const filteredArray = props.filteredClasses.sort((a, b) => {
    return a.StartTime.localeCompare(b.StartTime);
  })
  .sort(function sortByDay(a, b) {
    let day1 = a.Day;
    let day2 = b.Day;
    return daySorter[day1] - daySorter[day2];
  })

  // Filter to venue only classes
  const venueClasses = filteredArray.filter((t) => {
    return t.Venue.VenueName === props.Venue;
  });

  if (venueClasses.length > 0) {
    return (
      <>
        <Row>
          <Col>
            <h3 className='mt-4 text-center'>{props.Venue}</h3>
          </Col>
        </Row>
        <Table
          striped
          bordered
          hover
          responsive
          size='sm'
          className='text-center shadow one_line_table'
        >
          <thead>
            <tr>
              <th className='d-none d-md-table-cell'>Day</th>
              <th className='d-none d-md-table-cell'>Time</th>
              <th className='d-none d-md-table-cell'>Venue</th>
              <th className='d-table-cell d-md-none'>Details</th> {/*MobileOnlyBlock*/}
              <th>Type</th>
              <th>Subscribe</th>
            </tr>
          </thead>
          <tbody>
            {venueClasses
              .map((ClassSession) => (
                <tr key={ClassSession._id}>
                  <td className='align-self-center align-middle d-none d-md-table-cell view-table'>
                    {ClassSession.Day}
                  </td>
                  <td className='align-self-center align-middle d-none d-md-table-cell view-table'>
                    <strong>
                      {ClassSession.StartTime} - {ClassSession.FinishTime}
                    </strong>
                  </td>
                  <td className='align-self-center align-middle d-none d-md-table-cell view-table'>
                    {ClassSession.Venue.VenueName}
                  </td>
                  {/*MobileOnlyBlockStarts*/}
                  <td className='align-self-center align-middle d-table-cell d-md-none view-table'>
                    {ClassSession.Day}
                    <br />
                    <strong>
                      {ClassSession.StartTime} - {ClassSession.FinishTime}
                    </strong>
                  </td>
                  {/*MobileOnlyBlockEnds*/}
                  <td className='align-self-center align-middle view-table'>
                    {ClassSession.LessonType}
                  </td>
                  {isAuthenticatedCustomer() ? (
                    <td className='align-self-center align-middle view-table'>
                      {ClassSession.MaxLearners > ClassSession.Subscribers_Number ? (
                        <Button
                          variant='success'
                          size='sm'
                          as={Link}
                          to={`/checkout/${ClassSession._id}`}
                          className="w-100"
                        >
                          Subscribe
                        </Button>
                      ) : (
                        <Button
                          variant='secondary'
                          size='sm'
                          as={Link}
                          to={`/checkout/${ClassSession._id}`}
                          className="w-100"
                        >
                          Join Waiting List
                        </Button>
                      )}
                    </td>
                  ) : (
                    ""
                  )}

                  {!isAuthenticatedCustomer() ? (
                    <td className='align-self-center align-middle view-table'>
                      {ClassSession.MaxLearners > ClassSession.Subscribers_Number ? (
                        <Button
                          variant='success'
                          size='sm'
                          as={Link}
                          to={`/signup/${ClassSession._id}`}
                          className="w-100"
                        >
                          Subscribe
                        </Button>
                      ) : (
                        <Button
                          variant='secondary'
                          size='sm'
                          as={Link}
                          to={`/signup/${ClassSession._id}`}
                          className="w-100"
                        >
                          Join Waiting List
                        </Button>
                      )}
                    </td>
                  ) : (
                    ""
                  )}
                </tr>
              ))}
          </tbody>
        </Table>
      </>
    );
  } else {
    return null;
  }
};

//export the component
export default CustomerClassViewer;
